// Section for import npm components ------------------------------------------------------------------------------------
import React, { useContext } from 'react';

// MUI components
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

// Section for import custom components --------------------------------------------------------------------------------
import { AppConfigContext } from '@providers/AppConfigProvider';
import { MansionReviewContext } from '@providers/MansionDetail/MansionReview/MansionReviewProvider';
import TotalScoreRating from '@components/MansionDetail/MansionReview/TotalScoreRating';
import Chart from '@components/MansionDetail/MansionReview/Chart';
import ChartSP from '@components/MansionDetail/MansionReview/ChartSP';
import ReviewList from '@components/MansionDetail/MansionReview/ReviewList';

// Section for type definition -----------------------------------------------------------------------------------------

// CSSの共通使用する値を設定
const label = 'h-10 leading-10 bg-gray-01 text-center text-base font-bold text-rf-black';
export default function ComprehensiveEvaluation(): React.JSX.Element {
  const { isMobile } = useContext(AppConfigContext);
  const mansionReviewContext = useContext(MansionReviewContext);
  // @ts-ignore
  const { mansionReview } = mansionReviewContext;
  return (
    <Box className="w-full md:flex md:gap-x-[10%] md:pt-10 md:border-t md:border-gray-02">
      <Box className="md:w-[26%]">
        <TotalScoreRating
          title={mansionReview.category['total'].score.title}
          score={mansionReview.category['total'].score.score}
          countViewers={mansionReview.category['total'].reviewCount}
          isReview={mansionReview.category.total.isReview}
        />
      </Box>
      <Box className="md:w-[64%]">
        <Typography variant="h3" className={`${label} max-md:hidden md:z-10 md:top-4`}>
          口コミによる総合評価のスコア
        </Typography>
        <Box className="mt-8 max-md:mt-6 ">
          <Box className="max-md:mx-1 mb-8 max-md:mb-5">{isMobile ? <ChartSP /> : <Chart />}</Box>
          <ReviewList category="total" />
        </Box>
      </Box>
    </Box>
  );
}
